import { z } from 'zod'

export const SignInSchema = z.object({
    email: z.string().email({
        message: "L'email est invalide",
    }),
    password: z.string().min(6, {
        message: 'Le mot de passe doit contenir au moins 6 caractères',
    }),
})

export type SignInSchemaDto = z.infer<typeof SignInSchema>
